var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec1e24;}.cls-2{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{fill-rule:evenodd;}.cls-3{fill:#00a551;}.cls-4{fill:#fd0;}.cls-5{fill:#f1b70e;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#radial-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.08,
    y1: 61.85,
    x2: 87.78,
    y2: 61.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#054c9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 57.98,
    cy: 56.96,
    r: 24.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007db6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 38.06,
    y1: 58.25,
    x2: 88.34,
    y2: 58.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38.06,
    y1: 56.16,
    x2: 87.93,
    y2: 56.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0061b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192d7f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1.05,
    width: 125,
    height: 122.89,
    rx: 15.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.9,6h87.2a13.53,13.53,0,0,1,13.49,13.49v86.06A13.53,13.53,0,0,1,106.1,119H18.9A13.53,13.53,0,0,1,5.41,105.53V19.47A13.53,13.53,0,0,1,18.9,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.79,9.44h85.42c5.87,0,10.68,4.51,10.68,10v86.08c0,5.51-4.81,10-10.68,10H19.79c-5.87,0-10.68-4.51-10.68-10V19.46c0-5.51,4.81-10,10.68-10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.6,26.11l34.05,30.12a8.28,8.28,0,0,1-.12,12.69L69.75,98.79a11.14,11.14,0,0,1-14.35.11l-34-30.12a8.29,8.29,0,0,1,.12-12.7L55.25,26.21a11.13,11.13,0,0,1,14.35-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.17,39.88A25,25,0,0,1,86.36,64,25.68,25.68,0,0,1,61.89,90.41a25,25,0,0,1-26.2-24.1A25.69,25.69,0,0,1,60.17,39.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.28,87.12A25,25,0,0,1,37.09,63,25.7,25.7,0,0,1,61.57,36.58a25,25,0,0,1,26.19,24.1A25.69,25.69,0,0,1,63.28,87.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.05,83.35c-13.87.35-25.5-9.94-26-23s10.4-23.89,24.27-24.24,25.51,9.94,26,23S77.93,83,64.05,83.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.06,59.32c18.59-8.16,35-9.58,49.42-4.72l.25.09a22.2,22.2,0,0,1,.6,4.42v.13a1.65,1.65,0,0,1-.38-.05c-17.5-3.84-33.77-.74-49.3,5.51a22,22,0,0,1-.58-4.32c0-.35,0-.71,0-1.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.93,55.65c-20.22-4.78-38.67.6-49.84,4.86a.57.57,0,0,1,0-.13c0-.35,0-.71,0-1.06,18.59-8.16,35-9.58,49.42-4.72l.25.09C87.81,55,87.87,55.33,87.93,55.65Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon3);
export default __webpack_public_path__ + "static/media/card-icon-3.5ba423eee8850daaf65aa7d43deb44c6.svg";
export { ForwardRef as ReactComponent };